"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TableProps", {
  enumerable: true,
  get: function get() {
    return _types.TableProps;
  }
});
Object.defineProperty(exports, "ASCENDING", {
  enumerable: true,
  get: function get() {
    return _useSortableHeaders.ASCENDING;
  }
});
Object.defineProperty(exports, "DESCENDING", {
  enumerable: true,
  get: function get() {
    return _useSortableHeaders.DESCENDING;
  }
});
Object.defineProperty(exports, "SortingTypes", {
  enumerable: true,
  get: function get() {
    return _useSortableHeaders.SortingTypes;
  }
});
Object.defineProperty(exports, "UNSORTED", {
  enumerable: true,
  get: function get() {
    return _useSortableHeaders.UNSORTED;
  }
});
exports.default = void 0;

var _propTypes = require("@decisiv/prop-types");

var _get = _interopRequireDefault(require("lodash/get"));

var _propTypes2 = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _modifiersPropApplies = _interopRequireDefault(require("../../utils/modifiersPropApplies"));

var _Body = _interopRequireDefault(require("./Body"));

var _Container = _interopRequireDefault(require("./Container"));

var _Toolbar = _interopRequireDefault(require("./Toolbar"));

var _Foot = _interopRequireDefault(require("./Foot"));

var _Head = _interopRequireDefault(require("./Head"));

var _Provider = _interopRequireDefault(require("./Provider"));

var _schema = _interopRequireDefault(require("./schema"));

var _types = require("./types");

var _utils = require("./utils");

var _Grip = _interopRequireDefault(require("./Grip"));

var _useSortableHeaders = require("./hooks/useSortableHeaders");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function Table(props) {
  var data = props.data,
      defaultSort = props.defaultSort,
      footer = props.footer,
      toolbar = props.toolbar,
      columnsProp = props.columns,
      onDragEnd = props.onDragEnd,
      _props$dragVariant = props.dragVariant,
      dragVariant = _props$dragVariant === void 0 ? 'row' : _props$dragVariant,
      rest = _objectWithoutProperties(props, ["data", "defaultSort", "footer", "toolbar", "columns", "onDragEnd", "dragVariant"]);

  var _useState = (0, _react.useState)({}),
      _useState2 = _slicedToArray(_useState, 2),
      columnsWidth = _useState2[0],
      setColumnsWidth = _useState2[1];

  var onColumnResize = (0, _react.useCallback)(function (name, width) {
    setColumnsWidth(function (prevColumnsWidth) {
      return _objectSpread({}, prevColumnsWidth, _defineProperty({}, name, width));
    });
  }, []);
  var isDnDEnabled = !!onDragEnd;

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      hasDragHandlers = _useState4[0],
      setHasDragHandlers = _useState4[1];

  var columns = (0, _react.useMemo)(function () {
    if (isDnDEnabled && !hasDragHandlers) {
      return [{
        name: 'default-drag-handle',
        DataCell: function DataCell(_ref) {
          var DragHandle = _ref.DragHandle;

          if (dragVariant === 'handle') {
            var defaultHandle = _react.default.cloneElement(DragHandle, {
              'data-drag-handle-context-id': undefined
            });

            return defaultHandle;
          }

          return _react.default.createElement("div", null, _react.default.createElement(_Grip.default, null));
        },
        getHeaderCellAttrs: function getHeaderCellAttrs() {
          return {
            className: 'handle-container'
          };
        },
        getCellAttrs: function getCellAttrs() {
          return {
            className: 'handle-container'
          };
        },
        getCellKey: function getCellKey() {
          return 'default-drag-handle';
        },
        fixed: columnsProp[0].fixed
      }].concat(_toConsumableArray(columnsProp));
    }

    return columnsProp;
  }, [isDnDEnabled, hasDragHandlers, columnsProp, dragVariant]);
  var fixedColumns = (0, _react.useMemo)(function () {
    return (0, _utils.calculateOffsets)(columns, columnsWidth);
  }, [columns, columnsWidth]);
  return _react.default.createElement(_Provider.default, {
    defaultSort: defaultSort,
    onColumnResize: onColumnResize,
    columnsWidth: columnsWidth,
    fixedColumns: fixedColumns,
    isDnDEnabled: isDnDEnabled,
    hasDragHandlers: hasDragHandlers,
    setHasDragHandlers: setHasDragHandlers,
    dragVariant: dragVariant
  }, _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Toolbar.default, {
    kind: rest.kind,
    toolbar: toolbar
  }), _react.default.createElement(_Container.default, _extends({}, rest, {
    hasFooter: !!footer
  }), _react.default.createElement("table", null, _react.default.createElement(_Head.default, _extends({}, rest, {
    columns: columns
  })), _react.default.createElement(_Body.default, _extends({}, rest, {
    columns: columns,
    data: data,
    onDragEnd: onDragEnd
  })))), _react.default.createElement(_Foot.default, {
    kind: rest.kind,
    variant: rest.variant,
    footer: footer
  })));
}

Table.propTypes = _objectSpread({}, _schema.default.propTypes, {
  GroupHeader: (0, _propTypes.requireIf)(_propTypes2.default.elementType, function (_ref2) {
    var rowDataPath = _ref2.rowDataPath;
    return !!rowDataPath;
  }),
  // eslint-disable-next-line react/require-default-props
  columns: function columns(props, propName, componentName) {
    var scroll = props.scroll,
        columns = props.columns;

    if (columns.some(function (column) {
      return !!column.fixed;
    }) && (Array.isArray(scroll) ? !scroll.includes('x') : scroll !== 'x')) {
      return new Error("You have set a column as fixed but the Table doesn't have horizontal scroll, you need to enable it via scroll prop for this feature to work correctly");
    }

    var previousColumn = null;
    var isleColumnIndex = null;

    for (var index = 0; index < columns.length; index += 1) {
      var column = columns[index];

      if (previousColumn && column.fixed && !previousColumn.fixed) {
        isleColumnIndex = index;
        break;
      }

      previousColumn = column;
    }

    previousColumn = null;

    for (var _index = columns.length - 1; _index >= 0; _index -= 1) {
      var _column = columns[_index];

      if (previousColumn && _column.fixed && !previousColumn.fixed) {
        if (isleColumnIndex && isleColumnIndex <= _index) {
          return new Error("Column [".concat(_column.name, "] will not be fixed. Fixed columns must be consecutive, grouped at the beginning or at the end of the array."));
        }
      }

      previousColumn = _column;
    }

    _propTypes2.default.checkPropTypes({
      columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        DataCell: _propTypes2.default.elementType.isRequired,
        getCellKey: _propTypes2.default.func,
        name: _propTypes2.default.string.isRequired,
        sortBy: _propTypes2.default.func,
        title: _propTypes2.default.string,
        fixed: _propTypes2.default.bool
      }))
    }, props, propName, componentName);

    return null;
  },
  toolbar: _propTypes2.default.elementType,
  footer: _propTypes2.default.elementType,
  getRowKey: (0, _propTypes.requireIf)(_propTypes2.default.func, function (_ref3) {
    var data = _ref3.data;
    return !!data && data.length > 0 && !((0, _get.default)(data, '0.key') || (0, _get.default)(data, '0.id'));
  }),
  height: (0, _propTypes.requireIf)(_propTypes2.default.string, function (_ref4) {
    var scroll = _ref4.scroll,
        size = _ref4.size;
    return (0, _modifiersPropApplies.default)('y', scroll, size);
  }),
  scroll: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['x', 'y']), _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['x', 'y'])), _propTypes2.default.objectOf(_propTypes2.default.oneOfType([_propTypes2.default.oneOf(['x', 'y']), _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['x', 'y']))]))]),
  // eslint-disable-next-line react/require-default-props
  dragVariant: function dragVariant(_ref5) {
    var onDragEnd = _ref5.onDragEnd,
        props = _objectWithoutProperties(_ref5, ["onDragEnd"]);

    if (!onDragEnd && 'dragVariant' in props) return new Error('You have set dragVariant prop but Drag-and-Drop sorting is not enabled, you can enable it by passing [onDragEnd] callback');
    return null;
  }
});
Table.defaultProps = {
  GroupHeader: undefined,
  toolbar: undefined,
  footer: undefined,
  getRowKey: undefined,
  height: undefined,
  kind: 'primary',
  // eslint-disable-line react/default-props-match-prop-types
  scroll: undefined,
  variant: 'comfortable' // eslint-disable-line react/default-props-match-prop-types

};
var _default = Table;
exports.default = _default;